import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box,
} from "@material-ui/core";
import { toast } from "react-toastify";

const VARS = [
  { k: "{{nome}}", d: "nome do cliente" },
  { k: "{{numero}}", d: "número do cliente" },
  { k: "{{primeiro_nome}}", d: "primeiro nome" },
  { k: "{{resposta}}", d: "última resposta" },
];

const FlowBuilderNotifyModal = ({ open, onSave, onUpdate, data, close }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (open === "edit") {
      const d = data?.data || data || {};
      setName(d.name || "");
      setNumber(d.number || "");
      setMessage(d.message || "");
      setActiveModal(true);
    } else if (open === "create") {
      setName(""); setNumber(""); setMessage("");
      setActiveModal(true);
    }
  }, [open, data]);

  const handleClose = () => { close(null); setActiveModal(false); };

  const handleSave = () => {
    const digits = String(number).replace(/\D/g, "");
    if (digits.length < 12) {
      toast.error("Informe o número com DDI e DDD. Ex: 5511999999999");
      return;
    }
    if (!message.trim()) { toast.error("Escreva a mensagem da notificação."); return; }
    const payload = { name: name || "Notificação", number: digits, message };
    if (open === "edit") onUpdate({ ...data, data: { ...(data?.data || {}), ...payload } });
    else onSave(payload);
    handleClose();
  };

  const addVar = (v) => setMessage((old) => `${old}${v}`);

  return (
    <Dialog open={activeModal} onClose={handleClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>{open === "create" ? "Adicionar Notificação" : "Editar Notificação"}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" style={{ color: "#6b7280", marginBottom: 12 }}>
          Envia um aviso por WhatsApp para um número seu quando o fluxo passar por aqui.
          Útil para saber em que ponto o cliente chegou.
        </Typography>

        <TextField label="Nome" value={name}
          onChange={(e) => setName(e.target.value)} fullWidth size="small"
          variant="outlined" style={{ marginBottom: 12 }}
          helperText="Ex: Atendente, Comercial, Meu celular" />

        <TextField label="Número" value={number}
          onChange={(e) => setNumber(e.target.value)} fullWidth size="small"
          variant="outlined" style={{ marginBottom: 12 }}
          helperText="Com DDI e DDD, só números. Ex: 5511999999999" />

        <TextField label="Mensagem" value={message}
          onChange={(e) => setMessage(e.target.value)} fullWidth multiline
          minRows={3} size="small" variant="outlined" style={{ marginBottom: 8 }} />

        <Box style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
          {VARS.map((v) => (
            <Button key={v.k} size="small" variant="outlined"
              onClick={() => addVar(v.k)}
              style={{ textTransform: "none", fontSize: 11 }}>
              {v.k}
            </Button>
          ))}
        </Box>

        <Box style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: 10 }}>
          <Typography variant="caption" style={{ color: "#92400e" }}>
            <b>Atenção (API Oficial):</b> a Meta só permite enviar para quem falou com
            você nas últimas 24h. Para receber sempre, mande uma mensagem qualquer
            desse número para o seu WhatsApp oficial de vez em quando — isso reabre a janela.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          {open === "create" ? "Adicionar" : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderNotifyModal;
